import "../style.scss";
import { dateFunc } from "@/components/Functions/dateFunc";
import {
  GetCommonDeleteImgButton,
  GetCommonEditImgButton,
} from "@/components/Images/CommonImages";
import { MotifChip } from "@ey-xd/motif-react";
import { useSelector } from "react-redux";
type deleteType = (
  modalShow: boolean,
  userId: string,
  oid: string,
  displayName: string
) => void;
interface CustomCellRenderProps {
  handleDelete: deleteType;
  isUserEditPermission: boolean;
  isUserDeletePermission: boolean;
}
export const useCustomCellRenderers = ({
  handleDelete,
  isUserEditPermission,
  isUserDeletePermission,
}: CustomCellRenderProps) => {
  const user = useSelector((state: any) => state.user);
  const userRenderers = {
    displayNameRenderer: function (params: any) {
      return (
        <div className="display-flex">
          <div>{params.data.displayName}</div>
          {params?.listOfRecentUserIds?.includes(params.data.userId) && (
            <>&nbsp;<MotifChip variant="success">New</MotifChip></>
          )}
        </div>
      );
    },
    createdOnRenderer: function (params: any) {
      const { data } = params;
      return <>{dateFunc(data?.lastUpdatedDate).formattedDateTime}</>;
    },
    actionCellRenderers: function (params: any) {
      const { data } = params;
      return (
        user?.id !== data?.oid && (
          <>
            {isUserEditPermission && (
              <GetCommonEditImgButton
                onClick={() => {
                  params.api.startEditingCell({
                    rowIndex: params.rowIndex,
                    colKey: "applicationRole",
                  });
                }}
                tooltipPlacment="left"
              ></GetCommonEditImgButton>
            )}

            {isUserDeletePermission && (
              <GetCommonDeleteImgButton
                onClick={() =>
                  handleDelete(true, data?.userId, data?.oid, data?.displayName)
                }
              ></GetCommonDeleteImgButton>
            )}
          </>
        )
      );
    },
  };
  return userRenderers;
};
export default useCustomCellRenderers;
